import { EnvironmentProviders, Provider } from '@angular/core';
import { environment } from 'environments/environment';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { SocketService } from './socket.service';

const socketConfig: SocketIoConfig = {
    url: environment.apiUrl,
};

export const provideSocket = (): Array<Provider | EnvironmentProviders> => {
    return [
        SocketService,
        {
            provide: SocketIoModule,
            useFactory: () => SocketIoModule.forRoot(socketConfig), // Use factory to create the Socket instance
            multi: true,
        },
    ];
};
